import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MyCourses = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.37 5.779a.88.88 0 0 1 .718-.004l21.387 9.449a.88.88 0 0 1 .033 1.595L22.12 27.316a.88.88 0 0 1-.783-.004L.484 16.815a.88.88 0 0 1 .033-1.588l20.852-9.448Zm.367 1.765L2.92 16.07l18.818 9.474 19.3-9.474-19.3-8.526Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.907 21.44a.88.88 0 0 1-.394 1.18l-21.11 10.556a.882.882 0 0 1-.806 0L.487 22.62a.88.88 0 0 1 .787-1.574L22 31.41l20.726-10.363a.88.88 0 0 1 1.18.394Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.907 27.306a.88.88 0 0 1-.394 1.181l-21.11 10.555a.882.882 0 0 1-.806 0L.487 28.487a.88.88 0 1 1 .787-1.574L22 37.276l20.726-10.363a.88.88 0 0 1 1.18.393Z"
  }));
});
MyCourses.displayName = 'MyCourses';
MyCourses.defaultProps = {
  'aria-label': 'MyCourses'
};
export default MyCourses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MyCourses.js
// module id = 3853
// module chunks = 11